import React from 'react';
import {motion} from 'framer-motion';
import DisabledWrapper from "@/components/DisabledWrapper";

interface VideoEditorOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
}

const VideoEditorOverlay: React.FC<VideoEditorOverlayProps> = ({className, ...props}) => {
    return (
        <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: 0.5, ease: "easeInOut"}}
        >
            <DisabledWrapper style={{
                background: `linear-gradient(180deg, rgba(0, 26, 92, 0.8) 77.27%, rgba(0, 70, 250, 0.8) 100%)`,
                backgroundBlendMode: 'soft-light'
            }}></DisabledWrapper>
        </motion.div>
    );
};

export default VideoEditorOverlay;
